import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, Subject, tap, throwError } from 'rxjs';
import { LoginResponse } from '../auth/auth.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private apiUrl = environment.api + '/auth/login'; // URL API Login
  private tokenKey = environment.accessTokenName;
  private loginStatus$ = new Subject<boolean>();
  loginStatusChanged$ = this.loginStatus$.asObservable();

  constructor(
    private http: HttpClient // private router: Router,
  ) {}

  isAuthenticated(): boolean {
    return !!localStorage.getItem(this.tokenKey);
  }

  getToken(): string {
    const bearerToken = localStorage.getItem(this.tokenKey);
    if (bearerToken) {
      return bearerToken;
    }
    return '';
  }

  login(email: string, password: string): Observable<LoginResponse> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post<LoginResponse>(this.apiUrl, { email, password }, { headers }).pipe(
      tap((response) => {
        if (response.code === 0) {
          localStorage.setItem(this.tokenKey, response.data.accessToken);
          localStorage.setItem('roles', JSON.stringify(response.data.roles));
          this.loginStatus$.next(true);
          // this.router.navigate(['/']).then(r => {});
        } else {
          // wrong password or email
          throw new Error(response.message);
        }
      }),
      catchError((error) => {
        console.error('Login Error:', error);
        return throwError(() => new Error(error.error?.message || 'Login failed'));
      })
    );
  }

  logout(): void {
    localStorage.removeItem(this.tokenKey);
  }
}
